export function discountPrice(price, label) {
  const p = parseFloat(String(price || "").replace(/[^0-9.]/g, ""));
  const m = /(\d+)\s*%/.exec(label || "");
  if (!p || !m) return null;
  const d = Math.round(p * (1 - parseInt(m[1], 10) / 100));
  return `$${d.toLocaleString("en-US")}${String(price).includes("/mo") ? "/mo" : ""}`;
}

// Maps a challenge model label to its filter family (Instant / 1-Step / 2-Step / plan name).
const FAMILY_ORDER = ["Instant", "1-Step", "2-Step"];
const FAMILY_SPECIAL = { "Straight to Funded": "Straight to Funded" };

export function challengeFamily(model) {
  const m = String(model || "");
  if (FAMILY_SPECIAL[m]) return FAMILY_SPECIAL[m];
  if (/swing/i.test(m)) return "2-Step";
  if (/instant/i.test(m)) return "Instant";
  if (/^1[- ]step/i.test(m)) return "1-Step";
  if (/^2[- ]step/i.test(m)) return "2-Step";
  return m.split(" ")[0] || "Other";
}

export function familySort(a, b) {
  const ia = FAMILY_ORDER.indexOf(a);
  const ib = FAMILY_ORDER.indexOf(b);
  return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib) || a.localeCompare(b);
}
